import {getSafeEventDate}  from '../utils/dateTimeUtils'

const initialState = {
    data:                   [],
    visibilityFilter:       "SHOW_UPCOMING",
    searchKeyWord:          "",
    addEventDialogState:    false,
    currentEvent: {
        songSections: [],
        sections: [],
        djEventNote: "",
    },
    currentEventSongs:          [],
    matches:                    [],
    matchesFetched:             false,
    emailSent:                  false,
    newRecommendationsSaved:    false,
    zapTriggered:               false,
    exportedToSpotify:          false,
};

export default function (
    state = initialState, action) {

    switch (action.type) {
        case 'SET_EVENTS_FILTER': {
            return {...state, visibilityFilter: action.payload}
        }
        case 'SEARCH': {
            return {  ...state, searchKeyWord: action.payload}
        }

        case "FETCH_EVENTS_FULFILLED": {
            return {
                ...state,
                data: action.payload.data.map( event => {
                    let copy = Object.assign({}, event);
                    let date = getSafeEventDate(event.date);
                    copy.start = date;
                    copy.end = date;
                    return copy;
                })
            }
        }

        case "ADD_EVENT_FULFILLED": {
            return {
                ...state,
                currentEvent: action.payload.data,
                addEventDialogState: false,
            }
        }
        case "SET_ADD_EVENT_DIALOG_STATE": {
            return {
                ...state,
                addEventDialogState: action.payload,
            }
        }

        case "GET_EVENT_INFO_FULFILLED":
        case "EDIT_EVENT_FULFILLED":
        case "EDIT_EVENT_NOTE_FULFILLED":
        case "EDIT_SECTION_NOTE_FULFILLED":
        case "EDIT_ACTIVITY_TITLE_FULFILLED":
        case "EDIT_ACTIVITY_TIME_FULFILLED":
        case "REMOVE_ACTIVITY_TIME_FULFILLED":
        case "DELETE_ACTIVITY_FULFILLED":
        case "REORDER_EVENT_SECTIONS_FULFILLED":
        case "ADD_NEW_CONTACT_TO_EVENT_FULFILLED":
        case "UPDATE_CONTACT_IN_EVENT_FULFILLED":
        case "DELETE_CONTACT_FROM_EVENT_FULFILLED":
        {
            return {
                ...state,
                currentEvent: action.payload.data
            }
        }

        case "GET_SPOTIFY_SUGGESTIONS_PENDING":
        {
            return {
                ...state,
                receivedSpotifySuggestions: false,
            }
        }

        case "EXPORT_SECTION_TO_SPOTIFY_PENDING":
        {
            return {
                ...state,
                exportedToSpotify: false,
            }
        }

        case "GET_SPOTIFY_SUGGESTIONS_FULFILLED":
        {
            return {
                ...state,
                receivedSpotifySuggestions:                 true,
                spotifySuggestions:                         action.payload.data.spotifySuggestions,
                numSpotifySuggestionsAlreadyInSection:      action.payload.data.numSpotifySuggestionsAlreadyInSection,
                numSpotifySuggestionsNotAlreadyInSection:   action.payload.data.numSpotifySuggestionsNotAlreadyInSection,
                numSongsInSectionWithSpotifyLinks:          action.payload.data.numSongsInSectionWithSpotifyLinks,
                spotifySuggestionsAlreadyInSection:         action.payload.data.spotifySuggestionsAlreadyInSection,
                seedTracks:                                 action.payload.data.seedTracks,
            }
        }

        case "EXPORT_SECTION_TO_SPOTIFY_FULFILLED":
        {
            return {
                ...state,
                exportedToSpotify:              true,
                failedSpotifyTermsAndSongIds:   action.payload.data.failedSpotifyTermsAndSongIds,
                numberOfExportedSongs:          action.payload.data.numberOfExportedSongs,
                spotifyPlaylistName:            action.payload.data.spotifyPlaylistName,
            }
        }

        case "UPDATE_EVENT_SECTION_RECOMMENDATIONS_PENDING":
        {
            return {
                ...state,
                newRecommendationsSaved: false,
            }
        }

        case "UPDATE_EVENT_SECTION_RECOMMENDATIONS_FULFILLED":
        {
            return {
                ...state,
                currentEvent: action.payload.data,
                newRecommendationsSaved: true,
            }
        }

        case "NEW_SECTION_FULFILLED":{
            let newSection = action.payload.data.songSections[action.payload.data.songSections.length-1];
            let newSongs = state.currentEventSongs.slice();
            newSongs.push({
                sectionId: newSection.id,
                recType: newSection.recType,
                songs: []
            });
            return {
                ...state,
                currentEvent: action.payload.data,
                currentEventSongs: newSongs
            }
        }

        case "GET_EVENT_SONGS_FULFILLED": {
            return {
                ...state,
                currentEventSongs: action.payload.data
            }
        }

        case "GET_EVENT_SONGS_NOT_SYNC_FULFILLED": {
            return {
                ...state,
                currentEventSongs: action.payload.data
            }
        }

        case "SAVE_FLAG_EVENT_SONGS": {
            let newSongs = state.currentEventSongs.slice();
            newSongs.forEach(songSection => {
                songSection.songs.forEach(song =>  {
                    if (action.payload.songIds.includes(song.objectId)) {
                        song.isFlagged = action.payload.toFlag;
                    }
                })
            });
            return {
                ...state,
                currentEventSongs: newSongs
            }
        }

        case "ADD_EVENT_SPECIAL_SONG_FULFILLED": {
            let song;
            if (action.payload.data.existingSong) {
                song = action.payload.data.existingSong;
            } else {
                song = action.payload.data.newestSong;
            }
            return {
                ...state,
                song: song}
        }

        case "SAVE_SPECIAL_SONG_SECTION": {
            return {
                ...state, sectionId: action.payload
            }
        }
        case "GET_EVENT_PDF_FULFILLED":
        case "GET_PLANNING_FORM_PDF_FULFILLED": {
            window.open(action.payload.data, '_self');
            return state;
        }

        case "CREATE_EVENT_DEEP_LINK_FULFILLED": {
            let currentEvent = Object.assign({}, state.currentEvent);
            currentEvent.hostDeepLink = action.payload;
            return {
                ...state,
                currentEvent: currentEvent
            }
        }

        case "GET_SONGS_MATCHES_PENDING": {
            return {
                ...state,
                matchesFetched: false,
            }
        }

        case "GET_SONGS_MATCHES_FULFILLED":{
            return {
                ...state,
                matchesFetched: true,
                matches: action.payload.data,
            }
        }

        case "GET_SONGS_MATCHES_REJECTED": {
            return {
                ...state,
                matchesFetched: true,
                matches: [],
            }
        }

        case "SAVE_TEMPLATE_DETAILS_USED_FOR_ADD_EVENT": {
            return {
                ...state,
                templateUsed: action.payload,
            }
        }

        case "SEND_EVENT_LINK_EMAIL_TO_HOST_PENDING":{
            return {
                ...state,
                emailSent: false,
            }
        }

        case "SEND_EVENT_LINK_EMAIL_TO_HOST_FULFILLED":{
            return {
                ...state,
                emailSent: true,
            }
        }

        case "PLACE_PAYMENT_TO_VIBO_FULFILLED":{
            return {
                ...state
            }
        }

        case "SEND_ZAPIER_EVENT_DETAILS_TRIGGER_PENDING":{
            return {
                ...state,
                zapTriggered: false,
            }
        }

        case "SEND_ZAPIER_EVENT_DETAILS_TRIGGER_FULFILLED":{
            return {
                ...state,
                zapTriggered: true,
            }
        }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/eventsReducer.js